module.exports = __webpack_public_path__ + "static/media/icon-topic-revision.084ce570.svg";